import { ConnectButton } from "@rainbow-me/rainbowkit";

export function WalletButton() {
  return (
    <ConnectButton.Custom>
      {({ account, chain, openAccountModal, openChainModal, openConnectModal, mounted }) => {
        const ready = mounted;
        return (
          <div
            aria-hidden={!ready}
            style={!ready ? { opacity: 0, pointerEvents: "none", userSelect: "none" } : undefined}
            className="flex items-center gap-2"
          >
            {(() => {
              if (!ready || !account || !chain) {
                return (
                  <button
                    type="button"
                    onClick={openConnectModal}
                    className="rounded-md border border-border px-3 py-1.5 text-xs font-medium text-foreground hover:border-foreground/40 hover:bg-muted"
                  >
                    Connect wallet
                  </button>
                );
              }
              if (chain.unsupported) {
                return (
                  <button
                    type="button"
                    onClick={openChainModal}
                    className="rounded-md border border-red-500 bg-red-500/10 px-3 py-1.5 text-xs font-medium text-red-700 dark:text-red-300"
                  >
                    Wrong network
                  </button>
                );
              }
              return (
                <button
                  type="button"
                  onClick={openAccountModal}
                  title={account.address}
                  className="rounded-md border border-border px-3 py-1.5 font-mono text-xs hover:border-foreground/40 hover:bg-muted"
                >
                  {account.displayName}
                </button>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
}
